import React from "react";
import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

import { brand, fonts } from "../../../themes/theme";

/**
 * Selector de ventana temporal (24/12/6 meses).
 *
 * - Sin `onChange` (Cohort Overview): no hay dataset alternativo por ventana
 *   aqui, asi que se muestra fijo en "24 meses", sin poder elegir otro valor
 *   (pedido explicito: si no cambia nada, mejor no dejar elegir).
 * - Con `onChange` (Cohort Journey): select funcional y controlado por el
 *   padre, que si tiene datos por ventana.
 *
 * @param {string} tPrefix - namespace i18n de la vista (p.ej. "views.pharmaCohortOverview")
 * @param {string} [value] - valor controlado ("24"|"12"|"6"), solo si hay onChange
 * @param {function} [onChange]
 */
function WindowSelect({ tPrefix, value, onChange }) {
    const { t } = useTranslation();
    const label = t(`${tPrefix}.filters.windowLabel`);

    if (!onChange) {
        return (
            <Box sx={{ display: "flex", alignItems: "center", gap: 0.75 }}>
                <Typography sx={{ fontSize: 11, color: "text.secondary" }}>{label}:</Typography>
                <Box
                    sx={{
                        p: "5px 9px",
                        bgcolor: brand.gray50,
                        border: "1px solid",
                        borderColor: brand.borderLight,
                        borderRadius: "7px",
                        fontSize: 12,
                        color: "text.secondary",
                    }}
                >
                    {t(`${tPrefix}.filters.window24`)}
                </Box>
            </Box>
        );
    }

    return (
        <Box sx={{ display: "flex", alignItems: "center", gap: 0.75 }}>
            <Typography sx={{ fontSize: 11, color: "text.secondary" }}>{label}:</Typography>
            <Box
                component="select"
                aria-label={label}
                value={value}
                onChange={(e) => onChange(e.target.value)}
                sx={{
                    p: "5px 9px",
                    bgcolor: "#fff",
                    border: "1px solid",
                    borderColor: brand.borderLight,
                    borderRadius: "7px",
                    fontSize: 12,
                    color: "text.primary",
                    fontFamily: fonts.body,
                    cursor: "pointer",
                    outline: "none",
                    "&:focus": { borderColor: "primary.main" },
                }}
            >
                <option value="24">{t(`${tPrefix}.filters.window24`)}</option>
                <option value="12">{t(`${tPrefix}.filters.window12`)}</option>
                <option value="6">{t(`${tPrefix}.filters.window6`)}</option>
            </Box>
        </Box>
    );
}

export default WindowSelect;
